import React from "react";
import { MainPrice } from "./MainPriceDisplay.styles";
import { PriceContent } from "./PriceContent";
export function MainPriceDisplay({
  className,
  canvasScale,
  styles,
  position,
  length,
  imageUrl,
  commonMultiplier,
  price,
  unity,
}) {
  return (
    <MainPrice
      className={`flex CONTENT WRAPPER ${className || ""}`}
      canvasScale={canvasScale}
      styles={styles}
      position={position}
      length={length}
      imageUrl={imageUrl}
      heightMultiplier={1.15 * commonMultiplier}
      widthMultiplier={3 * commonMultiplier}
      intMultiplier={3 * commonMultiplier}
      decMultipier={1.2 * commonMultiplier}
      signMultiplier={0.6 * commonMultiplier}
    >
      <PriceContent
        price={price}
        styles={styles}
        unity={unity}
        canvasScale={canvasScale}
      />
    </MainPrice>
  );
}
